import axios from "axios";
import Cookies from "js-cookie";
import { formatRateLimitMessage } from "../../utils/rateLimitMessage";

// Extend AxiosRequestConfig to include our custom flag
declare module "axios" {
  export interface AxiosRequestConfig {
    skipAuthRedirect?: boolean;
  }
}

export const backendUrl =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:3000";

const backendAxios = axios.create({
  baseURL: backendUrl,
});

backendAxios.interceptors.request.use((config) => {
  const token = Cookies.get("api_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers["NovoNote-Version"] = `fe/${window.APP_VERSION}`;

  return config;
});

backendAxios.interceptors.response.use(
  (response) => {
    // Backend API doesn't need version checking logic
    // Just return the response
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 429) {
      const retryAfter = error.response.headers["retry-after"];
      const rateLimitError = new Error(formatRateLimitMessage(retryAfter));
      (rateLimitError as any).isRateLimited = true;
      (rateLimitError as any).retryAfter = retryAfter;
      return Promise.reject(rateLimitError);
    }

    if (error.response && error.response.status === 401) {
      // Skip redirect if this is a storage cleanup call
      if (error.config?.skipAuthRedirect) {
        return Promise.reject(error);
      }

      // Backend is a separate service, don't redirect to NovoPsych login
      // Just reject the promise and let the calling code handle it
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default backendAxios;
